import {IBaseFormFieldSettings} from "../../base-form-field.settings";
import {IDataCardDialogSettings} from "../../../../../data-card";


export interface IWysiwygFieldSettings extends IBaseFormFieldSettings {
  mediaDialogSettings?: IDataCardDialogSettings;
}
